import { useTRPC } from '@/utils/trpc';
import { QueryStateHandler } from '@liza/ui/components/QueryStateHandler';
import { ServiceRequestDetail } from '@liza/ui/components/records';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

type Props = {
  id: string;
};

export const ServiceRequest = ({ id }: Props): React.ReactElement => {
  const { t } = useTranslation('records');
  const trpc = useTRPC();

  const serviceRequestQuery = useQuery(trpc.patient.serviceRequest.get.queryOptions({ id }));

  return (
    <QueryStateHandler query={serviceRequestQuery} emptyMessage={t('noServiceRequestsFound')}>
      {(data) => <ServiceRequestDetail serviceRequest={data.serviceRequest} />}
    </QueryStateHandler>
  );
};
